import get from 'lodash.get'

import {
  USERS_LOGOUT,
  USERS_FAIL_LOGIN,
  USERS_REQUEST_LOGIN,
  USERS_SUCCESS_LOGIN
} from '../actions/users'

const INITIAL_STATE = {
  loading: false, data: {}, error: ''
}

const citiesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USERS_LOGOUT:
      return Object.assign({}, state, {
        data: {},
        error: '',
        loading: false
      })
    case USERS_FAIL_LOGIN:
      return Object.assign({}, state, {
        data: {},
        error: 'Error',
        loading: false
      })
    case USERS_REQUEST_LOGIN:
      return Object.assign({}, state, {
        data: {},
        error: '',
        loading: true
      })
    case USERS_SUCCESS_LOGIN:
      return Object.assign({}, state, {
        data: get(action, 'user', {}),
        error: '',
        loading: false
      })
    default:
      return state
  }
}

export default citiesReducer



// WEBPACK FOOTER //
// ./src/reducers/users.js